export default __webpack_public_path__ + "static/media/mrb_small.07cf8e12.png";